module.exports = __webpack_public_path__ + "static/media/alternator-mr-card-front.9f50f935.jpeg";